import CityPageTemplate from "../city-template/CityPageTemplate";
import { yarmouthConfig } from "./data";

export default function YarmouthPage() {
  return <CityPageTemplate config={yarmouthConfig} />;
}